// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { IRangeExSchema } from '../range/RangeExSchema';
import type { IGeoExV4Schema } from '../geo/GeoExV4Schema';
import type { IPriceRangeExSchema } from '../price_range/PriceRangeExSchema';

export interface IRequestMessageV5Schema {
  /** Площадь **/
  area?: IRangeExSchema | null;
  /** Комментарий **/
  comment?: string | null;
  /** Требуемая срочность завершения сделки **/
  dealPeriod: EDealPeriod;
  /** Тип сделки **/
  dealTypeEx: EDealTypeEx;
  /** E-mail **/
  email?: string | null;
  /** Первичная/вторичная недвижимость **/
  firstOrSecond?: EFirstOrSecond | null;
  /** ФИО **/
  fullName: string;
  /** Геоданные **/
  geo: IGeoExV4Schema;
  /** Объявление уже размещено? **/
  isHasOffer: boolean;
  /** Уже выбрали проект дома под строительство? **/
  isProjectExists?: boolean | null;
  /** Тестовая заявка **/
  isTest?: boolean | null;
  /** Наличие одобрения ипотеки от банка **/
  mortgageBankApprove: EMortgageBankApprove;
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  needLandForBuilding?: boolean | null;
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  needProject?: boolean | null;
  /** Тип объекта **/
  objectType: EObjectType;
  /** Требуемый тип недвижимости **/
  offerType: EOfferType;
  /** Телефон **/
  phone: string;
  /** Цена **/
  price?: IPriceRangeExSchema | null;
  /** Как планируете покупать квартиру? **/
  purchaseMethod?: EPurchaseMethod | null;
  /** Тип аренды **/
  rentType?: ERentType | null;
  /** Количество комнат **/
  roomCount?: ERoomCount[] | null;
  /** Источник заявки **/
  source?: string | null;
}
export enum EDealPeriod {
  /** Больше месяца **/
  'MoreMonth' = 'moreMonth',
  /** В течение месяца **/
  'OneMonth' = 'oneMonth',
  /** В течение недели **/
  'OneWeek' = 'oneWeek',
  /** В течение 7 дней **/
  'SevenDays' = 'sevenDays',
  /** В течение 6 месяцев **/
  'SixMonths' = 'sixMonths',
  /** В течение 3 месяцев **/
  'ThreeMonths' = 'threeMonths',
  /** В течение 12 месяцев **/
  'TwelveMonths' = 'twelveMonths',
  /** В течение 2-3 недель **/
  'TwoThreeWeeks' = 'twoThreeWeeks',
  /** В течение 2 недель **/
  'TwoWeek' = 'twoWeek',
}
export enum EDealTypeEx {
  /** Покупаю **/
  'Buy' = 'buy',
  /** Сдаю **/
  'Rent' = 'rent',
  /** Продаю **/
  'Sale' = 'sale',
  /** Продаю, чтобы купить **/
  'SellToBuy' = 'sellToBuy',
  /** Арендую **/
  'Tenant' = 'tenant',
}
export enum EFirstOrSecond {
  /** Неважно **/
  'DoesNotMatter' = 'doesNotMatter',
  /** Новостройка **/
  'First' = 'first',
  /** Вторичка **/
  'Second' = 'second',
}
export enum EMortgageBankApprove {
  /** В процессе **/
  'InProcess' = 'inProcess',
  /** Нет **/
  'No' = 'no',
  /** Да **/
  'Yes' = 'yes',
}
export enum EObjectType {
  /** Койко место **/
  'Bed' = 'bed',
  /** Здание **/
  'Building' = 'building',
  /** Готовый бизнес **/
  'Business' = 'business',
  /** Автосервис **/
  'CarService' = 'carService',
  /** Коммерческая земля **/
  'CommercialLand' = 'commercialLand',
  /** Коттедж **/
  'Cottage' = 'cottage',
  /** Бытовые услуги **/
  'DomesticServices' = 'domesticServices',
  /** Квартира **/
  'Flat' = 'flat',
  /** Доля в квартире **/
  'FlatShare' = 'flatShare',
  /** Помещение свободного назначения **/
  'FreeAppointmentObject' = 'freeAppointmentObject',
  /** Гараж **/
  'Garage' = 'garage',
  /** Дом **/
  'House' = 'house',
  /** Часть дома **/
  'HouseShare' = 'houseShare',
  /** Производство **/
  'Industry' = 'industry',
  /** Участок **/
  'Land' = 'land',
  /** Продажа квартиры в новостройке **/
  'NewBuildingFlat' = 'newBuildingFlat',
  /** Офис **/
  'Office' = 'office',
  /** Общепит **/
  'PublicCatering' = 'publicCatering',
  /** Комната **/
  'Room' = 'room',
  /** Торговая площадь **/
  'ShoppingArea' = 'shoppingArea',
  /** Таунхаус **/
  'Townhouse' = 'townhouse',
  /** Склад **/
  'Warehouse' = 'warehouse',
}
export enum EOfferType {
  /** коммерческая **/
  'Commercial' = 'commercial',
  /** квартиры **/
  'Flat' = 'flat',
  /** новостройки **/
  'Newobject' = 'newobject',
  /** загородка **/
  'Suburban' = 'suburban',
}
export enum EPurchaseMethod {
  /** Наличные **/
  'Cash' = 'cash',
  /** Материнский капитал **/
  'MaternalCapital' = 'maternalCapital',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
  /** Другое **/
  'Other' = 'other',
}
export enum ERentType {
  /** Любой **/
  'Any' = 'any',
  /** Посуточно **/
  'Daily' = 'daily',
  /** На несколько месяцев **/
  'FewMonths' = 'fewMonths',
  /** От года **/
  'Long' = 'long',
}
export enum ERoomCount {
  /** Пятикомнатная квартира **/
  'FiveRoom' = 'fiveRoom',
  /** Четырехкомнатная квартира **/
  'FourRoom' = 'fourRoom',
  /** Многокомнатная квартира (6 и более комнат) **/
  'Large' = 'large',
  /** Однокомнатная квартира **/
  'OneRoom' = 'oneRoom',
  /** Квартира со свободной планировкой **/
  'OpenPlan' = 'openPlan',
  /** Студия **/
  'Studio' = 'studio',
  /** Трехкомнатная квартира **/
  'ThreeRoom' = 'threeRoom',
  /** Двухкомнатная квартира **/
  'TwoRoom' = 'twoRoom',
}
